import React from 'react'

const ShippingManifest = () => {
  return (
    <div>ShippingManifest</div>
  )
}

export default ShippingManifest